import { render, staticRenderFns } from "./search-by-bags.vue?vue&type=template&id=320cc9c0"
import script from "./search-by-bags.vue?vue&type=script&lang=js"
export * from "./search-by-bags.vue?vue&type=script&lang=js"
import style0 from "./search-by-bags.vue?vue&type=style&index=0&id=320cc9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports